export default __webpack_public_path__ + "static/PromptIconTen-ce076ccebc95251d8bab1987fc66abe6.png";